module.exports = __webpack_public_path__ + "static/img/gz-img04.2e3c6b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gz-img04.jpg
// module id = PvX8
// module chunks = 1